import { all, call, fork, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import moment from "moment";
import { IS_LOADING, PLANNING_SELECT_EMAIL } from "../../../redux/types";
import {
  VACATION_ASK_VACATION,
  PRESENCE_SET_SELECTEDUSER_VACATIONS,
  VACATION_VALIDATE_VACATION,
  VACATION_REJECT_VACATION,
  VACATION_DELETE_VACATION,
  VACATION_MODIFY_VACATION,
  PRESENCE_SET_LIST_VACATIONS,
  PRESENCE_IS_LOADING,
  ABSENCE_DECLARE_ABSENCE
} from "../actions/presence";
import {
  sendVacationApi,
  fetchVacationsApi,
  rejectVacationApi,
  deleteVacationApi,
  validateVacationApi,
  modifyVacationApi,
  sendAbsenceDeclarationApi
} from "./vacation.api";
import { Modal } from "antd";
import { slotId, VACATION_REQUEST_STATUS_ID } from "../../../configs/constants";

const getAuthState = state => state.auth;
const getPlanningState = state => state.planning || {};

const get = (path, object, defaultValue = null) =>
  path.reduce((xs, x) => (xs && xs.hasOwnProperty(x) ? xs[x] : defaultValue), object);

export const handleFieldError = error => {
  const status = get(["response", "status"], error, 500);
  const textErrorSubstitute = get(["response", "statusText"], error, "Erreur de traitement");
  let textError = get(["response", "data", "error"], error, textErrorSubstitute);
  textError = textError + " (status : " + status + ")";
  const errorData = get(["response", "data", "data", "e"], error, textError);
  const fieldData = get(["response", "data", "data", "fields"], error, []);
  textError = get([fieldData[0], "message"], errorData, textError);

  Modal.error({ title: "Erreur", content: `${textError} ${fieldData ? " (" + fieldData + ")" : ""}` });
  return { title: "Erreur", concent: `${textError} ${fieldData ? " (" + fieldData + ")" : ""}` };
};

export const handleTeamError = error => {
  console.log("handleError", error.response.data);
  let textError = get(["response", "data", "data"], error, "Erreur de traitement");
  const errorData = get(["response", "data", "error"], error, "Erreur");
  Modal.error({ title: errorData, content: textError });
  return { title: errorData, concent: textError };
};

export const handleError = error => {
  const responseData = get(["response", "data"], error);
  if (responseData && typeof responseData.data === "string") return handleTeamError(error);
  return handleFieldError(error);
};

function* fetchUserVacations() {
  const authState = yield select(getAuthState);
  try {
    yield put({ type: IS_LOADING, payload: true });
    const planningState = yield select(getPlanningState);
    const selectedEmail = planningState.selectedEmail;
    const filters = {
      user_email: selectedEmail,
      "status.id": { $ne: VACATION_REQUEST_STATUS_ID.CANCELED }
    };
    const data = yield call(fetchVacationsApi, filters, authState.token);
    const vacations = data.map(vacation => {
      const start =
        vacation.start_date_slot.id === slotId.MORNING
          ? moment(vacation.start_date)
              .set({ hour: 0, minute: 0 })
              .format("x")
          : moment(vacation.start_date)
              .set({ hour: 12, minute: 0 })
              .format("x");
      const end =
        vacation.end_date_slot.id === slotId.MORNING
          ? moment(vacation.end_date)
              .set({ hour: 11, minute: 59 })
              .format("x")
          : moment(vacation.end_date)
              .set({ hour: 23, minute: 59 })
              .format("x");

      const vacationType = vacation.type || {};
      const status = vacation.status || {};
      const newVacation = { ...vacation };
      newVacation.start = parseInt(start);
      newVacation.end = parseInt(end);
      newVacation.title = vacationType.label || "N/C";
      newVacation.visitType = status.label;
      newVacation.type = status.id;
      newVacation.vacationTypeId = vacationType.id;

      return newVacation;
    });
    yield put({ type: PRESENCE_SET_SELECTEDUSER_VACATIONS, payload: vacations });
    yield put({ type: IS_LOADING, payload: false });
  } catch (e) {
    console.log("error fetchvacations", e.message);
  }
}

function* sendVacation(action) {
  const authState = yield select(getAuthState);
  const { payload: vacation } = action;
  try {
    yield put({ type: IS_LOADING, payload: true });
    yield call(sendVacationApi, vacation, authState.token);
    yield put({ type: IS_LOADING, payload: false });
    yield call(fetchUserVacations);
  } catch (e) {
    console.log("SendVacationError", e.message);
    yield call(handleError, e);
    yield put({ type: IS_LOADING, payload: false });
  }
}
function* sendAbsenceDeclaration(action) {
  const authState = yield select(getAuthState);
  const { payload: absence } = action;
  try {
    yield put({ type: IS_LOADING, payload: true });
    yield call(sendAbsenceDeclarationApi, absence, authState.token);
    yield put({ type: IS_LOADING, payload: false });
  } catch (e) {
    console.log("SendAbsenceError", e.message);
    yield call(handleError, e);
    yield put({ type: IS_LOADING, payload: false });
  }
}
function* modifyVacation(action) {
  const authState = yield select(getAuthState);
  const { payload: vacation } = action;
  try {
    yield put({ type: IS_LOADING, payload: true });
    yield call(modifyVacationApi, vacation, authState.token);
    yield put({ type: IS_LOADING, payload: false });
    yield call(fetchUserVacations);
  } catch (e) {
    console.log("error[REJECT]", e.message);
    yield call(handleError, e);
    yield put({ type: IS_LOADING, payload: false });
  }
}
function* validateVacation(action) {
  const authState = yield select(getAuthState);
  const payload = action.payload || {};
  const { vacation, refreshVacations, filters } = payload;
  try {
    yield put({ type: IS_LOADING, payload: true });
    yield call(validateVacationApi, vacation, authState.token);
    if (refreshVacations) {
      const data = yield call(fetchVacationsApi, filters, authState.token);
      yield put({ type: PRESENCE_SET_LIST_VACATIONS, payload: data });
    }
    yield put({ type: IS_LOADING, payload: false });
    yield call(fetchUserVacations);
  } catch (e) {
    console.log("error[VALIDATE]", e.message);
    yield call(handleError, e);
    yield put({ type: IS_LOADING, payload: false });
  }
}
function* rejectVacation(action) {
  const authState = yield select(getAuthState);
  const payload = action.payload || {};
  const { vacation, refreshVacations, filters } = payload;
  try {
    yield put({ type: IS_LOADING, payload: true });
    yield call(rejectVacationApi, vacation, authState.token);
    if (refreshVacations) {
      const data = yield call(fetchVacationsApi, filters, authState.token);
      yield put({ type: PRESENCE_SET_LIST_VACATIONS, payload: data });
    }
    yield put({ type: IS_LOADING, payload: false });
    yield call(fetchUserVacations);
  } catch (e) {
    console.log("error[REJECT]", e.message);
    yield call(handleError, e);
    yield put({ type: IS_LOADING, payload: false });
  }
}

function* deleteVacation(action) {
  const authState = yield select(getAuthState);
  const { payload: vacation } = action;

  try {
    yield put({ type: IS_LOADING, payload: true });
    yield call(deleteVacationApi, vacation, authState.token);
    yield put({ type: IS_LOADING, payload: false });
    yield call(fetchUserVacations);
  } catch (e) {
    console.log("error[DELETE]", e.message, e.response.data);
    yield call(handleError, e);
    yield put({ type: IS_LOADING, payload: false });
  }
}

function* watchAskVacation() {
  yield takeEvery(VACATION_ASK_VACATION, sendVacation);
}

function* watchDeclareAbsence() {
  yield takeEvery(ABSENCE_DECLARE_ABSENCE, sendAbsenceDeclaration);
}
function* watchModifyVacation() {
  yield takeEvery(VACATION_MODIFY_VACATION, modifyVacation);
}

export default function* root() {
  yield all([fork(watchModifyVacation), fork(watchDeclareAbsence)]);
}



// WEBPACK FOOTER //
// src/modules/presence/sagas/index.js